import { Button, makeStyles, Paper } from '@material-ui/core';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { useModal } from 'react-modal-hook';

import { TemplateInterface } from 'store/reducers/templates';

import ModalEnviarMensagemTemplate from './ModalEnviarMensagemTemplate';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginBlock: spacing(1),
  },
}));

interface ButtonSendTemplateMessageProps {
  onSendTemplate: (template: TemplateInterface) => void;
}

export default function ButtonSendTemplateMessage({
  onSendTemplate,
}: ButtonSendTemplateMessageProps) {
  const classes = useStyles();

  const [showModalEnviarMensagemTemplate, hideModalEnviarMensagemTemplate] =
    useModal(({ in: open }) => {
      return (
        <ModalEnviarMensagemTemplate
          open={open}
          onClose={hideModalEnviarMensagemTemplate}
          onSendTemplate={onSendTemplate}
        />
      );
    }, []);

  return (
    <Paper className={classes.root} elevation={0}>
      <Button
        variant="contained"
        color="primary"
        startIcon={<AssignmentIcon />}
        fullWidth
        size="large"
        onClick={showModalEnviarMensagemTemplate}
      >
        Clique aqui para enviar mensagem
      </Button>
    </Paper>
  );
}
